const $ = {
    yieldToken: '0xB2624CE11461fD4b02764825BDE2d94AEf8B70e1',//'0xd086f35f5b602329975430efbfa41f69a31e43e3',
    USDC: '0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174', //'0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174',
    accessToken: '0xa92d20Fe09aBb527dbCc58288d4C9b6042c8A123',//'0xa92d20Fe09aBb527dbCc58288d4C9b6042c8A123'
    yieldSale: '0x79eE12d78f12e1165324Fc2D62393F3f52df9C30',
    batchYield: '0x720a0B69Ff5dA2145e1fca236AC969fd41641379'
}

export default $

